import React, { useEffect } from 'react';
import UserListItem from './listitems/UserListItem';

import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  globalAssoSearchListingTypeEntity,
  PAGINATION_DEFAULT_LIMIT,
} from '../../constants/applicationConstants';

import './customListing.component.scss';

import { GLOBAL_ENITY } from '../../submodule';

import Pagination from '@material-ui/lab/Pagination';
import OrganizationList from './listitems/OrganationList';
import DiagnosisCodeListItem from './listitems/DiagnosisCodeListItem';
import ProceduresList from './listitems/ProcedureList';
import ImportListItem from './listitems/ImportListItem';
import StandardReport from './listitems/StanderdReport';
import ReportBuilderList from './listitems/ReportBuilderList';

const useStyles = makeStyles({
  paginationBox: {
    margin: '30px 0',
  },
});

const CustomListing = ({
  tableData,
  isLoaded,
  entityType,
  setSelectedItems,
  handleInlineStatusChange,
  filtersApplied,
  setFiltersApplied,
  setShowModal,
  setChangeIndex,
  addFormPopupHandler,
  startImport,
  previewAgain,
  downloadFile
}) => {
  const [listData, setListData] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);

  const classes = useStyles();

  function handlePaginationChange(event, value) {
    setPage(value);
  }
  useEffect(() => {
    let filteredData = [];

    if (tableData.length > 0) {
      filteredData = tableData.slice(
        (page - 1) * PAGINATION_DEFAULT_LIMIT,
        page * PAGINATION_DEFAULT_LIMIT,
      );
    } else {
      filteredData = [];
    }

    setListData(filteredData);

    let noOfPages = Math.ceil(tableData.length / PAGINATION_DEFAULT_LIMIT);

    if (noOfPages == 0) {
      noOfPages = 1;
    }
    setPageCount(noOfPages);
  }, [tableData, page]);

  useEffect(() => {
    if (filtersApplied) {
      setPage(1);
      setFiltersApplied(false);
    }
  }, [filtersApplied]);

  React.useEffect(() => {
    // if (isLoaded) return
    let selectedItemsList = [];
    if (listData && listData.length > 0) {
      listData.forEach(function (val, key) {
        if (val.checked && val.checked === true) {
          selectedItemsList.push(val);
        }
      });
    }
    setSelectedItems(selectedItemsList);
  }, [listData]);
  return (
    <Grid item md={12} style={{ margin: '20px' }} className="listingContainer">
      {
        // !isLoaded && listData && (listData.length>0) && listData.map((item, index) => {
        listData &&
          listData.map((item, index) => {
            switch (entityType) {
              case globalAssoSearchListingTypeEntity.users:                
                return (
                  <UserListItem
                    index={index}
                    key={item.PK}
                    pageNumber={page}
                    paginationLimit={PAGINATION_DEFAULT_LIMIT}
                    entityData={item}
                    listData={listData}
                    setListData={setListData}
                    handleInlineStatusChange={handleInlineStatusChange}
                    setShowModal={setShowModal}
                    setChangeIndex={setChangeIndex}
                  />
                );
              case globalAssoSearchListingTypeEntity.standard_report:                
                return (
                  <StandardReport
                    index={index}
                    key={item.PK}
                    pageNumber={page}
                    paginationLimit={PAGINATION_DEFAULT_LIMIT}
                    entityData={item}
                    listData={listData}
                    setListData={setListData}
                    handleInlineStatusChange={handleInlineStatusChange}
                    setShowModal={setShowModal}
                    setChangeIndex={setChangeIndex}
                  />
                );
              case globalAssoSearchListingTypeEntity.report_builder:                
                return (
                  <ReportBuilderList
                    index={index}
                    key={item.PK}
                    pageNumber={page}
                    paginationLimit={PAGINATION_DEFAULT_LIMIT}
                    entityData={item}
                    listData={listData}
                    setListData={setListData}
                    handleInlineStatusChange={handleInlineStatusChange}
                    setShowModal={setShowModal}
                    setChangeIndex={setChangeIndex}
                  />
                );
              case GLOBAL_ENITY.organization:
                return (
                  <OrganizationList
                    index={index}
                    key={item.PK}
                    entityData={item}
                    listData={listData}
                    setListData={setListData}
                    handleInlineStatusChange={handleInlineStatusChange}
                    setShowModal={setShowModal}
                    setChangeIndex={setChangeIndex}
                  />
                );
              case globalAssoSearchListingTypeEntity.diagnostic_codes:
                return (
                  <DiagnosisCodeListItem
                    index={index}
                    key={`listitem-${item.PK}`}
                    entityData={item}
                    listData={listData}
                    setListData={setListData}
                    handleInlineStatusChange={handleInlineStatusChange}
                    addFormPopupHandler={addFormPopupHandler}
                  />
                );
              case globalAssoSearchListingTypeEntity.procedures:
                return (
                  <ProceduresList
                    index={index}
                    key={`listitem-${item.PK}`}
                    entityData={item}
                    listData={listData}
                    setListData={setListData}
                    handleInlineStatusChange={handleInlineStatusChange}
                    addFormPopupHandler={addFormPopupHandler}
                  />
                );
              case globalAssoSearchListingTypeEntity.import:
                return (
                  <ImportListItem
                    index={index}
                    key={`listitem-${item.PK}`}
                    entityData={item}
                    listData={listData}
                    setListData={setListData}
                    handleInlineStatusChange={handleInlineStatusChange}
                    addFormPopupHandler={addFormPopupHandler}
                    startImport={startImport}
                    previewAgain={previewAgain}
                    downloadFile={downloadFile}
                  />
                );              
              default:
                return <div key="no_listing">No Listing</div>;
            }
          })
      }

      {/* {!isLoaded && (listData && listData.length) > 0 && (<Grid container spacing={2} alignItems="center" justifyContent='center' className={classes.paginationBox}> */}
      {!isLoaded && (listData && listData.length) > 0 && (
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          className={classes.paginationBox}
        >
          <Grid item>
            <Pagination
              count={pageCount}
              showFirstButton
              showLastButton
              page={page}
              onChange={handlePaginationChange}
            />
          </Grid>
        </Grid>
      )}

      {listData && listData.length == 0 && (
        <div
          style={{ fontWeight: 'bold', textAlign: 'center' }}
          data-testid="no-record"
        >
          No records found.
        </div>
      )}
    </Grid>
  );
};

CustomListing.defaultProps = {
  handleInlineStatusChange: function () {},
  setSelectedItems: function () {},
  addFormPopupHandler: function () {},
  startImport: function () {},
  previewAgain: function () {},
  downloadFile: function () {},
  moduleAccessPermissions: null,
  setShowModal: null,
  setChangeIndex: null,
};

export default CustomListing;
